module.exports = __webpack_public_path__ + "img/desc3.652b88d8.jpg";